<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card
                    header="Catalog tree"
                    border-variant="info"
                    header-bg-variant="primary"
                    header-text-variant="white"
                >
                    <div slot="header">
                        <span data-font="22">Inbox</span>
                    </div>
                    <b-card
                        border-variant="info"
                        header-bg-variant="primary"
                        header-text-variant="white"
                    >
                        <div class="mt-3">
                            <b-table
                                :fields="notificationColumns"
                                :items="notifications"
                                class="table-bordered table-sm"
                                :dark="dark"
                                :filter="filter"
                                :hover="hover"
                                thead-class="header"
                                :striped="striped"
                                :bordered="bordered"
                                :small="small"
                                :fixed="fixed"
                                ref="partners"
                            >
                                <template slot="cell(action)" slot-scope="data">
                                    <b-button
                                        size="sm"
                                        class="mr-2"
                                        variant="primary"
                                        @click="onMessageClick(data.item)"
                                    >
                                        <i class="fa fa-eye"></i>
                                    </b-button>
                                </template>
                                <template
                                    slot="cell(createdAt)"
                                    slot-scope="data"
                                >
                                    <div>
                                        {{ data.item.createdAt | formatedate }}
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div style="float: right">
                            <b-pagination
                                v-model="currentPage"
                                :per-page="perPage"
                                :total-rows="notifications.length"
                                aria-controls="my-table"
                                prev-text="Prev"
                                next-text="Next"
                                hide-goto-end-buttons
                            ></b-pagination>
                        </div>
                    </b-card>
                    <b-row v-if="notifications.length === 0">
                        <b-col md="12">
                            <b-alert
                                v-model="showAlert"
                                variant="info"
                                dismissible
                                >No Any Unread Messages!</b-alert
                            >
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { Vue, Component } from "vue-property-decorator";
import cTable from "@/views/base/Table.vue";
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import moment from "moment";

export default {
    name: "MyMessages",
    components: {
        cTable,
        AtomSpinner,
    },
    data: () => {
        return {
            currentPage: 1,
            filter: "",
            perPage: 10,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            notificationColumns: [
                {
                    key: "title",
                    label: "Title",
                },
                {
                    key: "message.customer.authentication.userName",
                    label: "Username",
                },
                {
                    key: "message.customer.authentication.email",
                    label: "Email",
                },
                {
                    key: "message.customer.authentication.phone",
                    label: "Phone",
                },
                {
                    key: "createdAt",
                    label: "Date",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    methods: {
        onMessageClick(messageData) {
            if (
                messageData.message.type === "order-request" ||
                data.message.type === "manufacturer-order-request"
            ) {
                let userdata = JSON.parse(sessionStorage.getItem("userLogin"));
                let object = {
                    uid: userdata._id,
                };
                this.$store.dispatch(
                    "notification/openNotificationModal",
                    true,
                );
                this.$store.dispatch(
                    "notification/setNewOrdersNotification",
                    messageData,
                );
                let orderLink =
                    this.$store.getters["notification/GetNewOrderNotification"];
                this.$store.dispatch(
                    "notification/getOrderDetails",
                    orderLink["message"]["orderDetailsLink"],
                );
            } else {
                let messageObj = {
                    id: messageData._id,
                };
                this.$socket.emit("read", messageObj);
                this.$socket.emit("getunread", object);
            }
        },
    },

    computed: {
        notifications() {
            return this.$store.getters["notification/GetAllNotifications"];
        },
        showAlert() {
            if (this.notifications.length === 0) {
                return true;
            } else {
                return false;
            }
        },

        totalRows() {
            return this.notifications.length;
        },
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("MM/DD/YYYY hh:mm a");
            }
        },
    },
};
</script>

<style scoped>
.overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.card-body {
    margin: 0;
    font-family: "Lato";
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: var(--secondary);
    text-align: left;
    background-color: #fafbfe;
    overflow-x: initial !important;
}

.checkbox-wrapper-mail {
    width: 30px;

    position: relative;
    left: 10px;

    vertical-align: middle;
}
.email-list > li .email-content .email-subject {
    width: 240px;
}
.email-list > li .email-content .email-date {
    right: 0;
    width: 200px;
    text-align: right;
    padding-left: 0px;
}
.wrap {
    /* border: 1px solid black; */
    width: 1100px;
    height: 500px;
    overflow: auto;
}

.email-list > li {
    position: relative;
    display: block;
    height: 45px;
    line-height: 45px;
    cursor: default;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
}
</style>
